import { useCurrentStore } from '@hooks/useCurrentStore.ts'
import NoAccessRoute from '@routes/NoAccessRoute.tsx'
import { type StoreRole, useUser } from '@state/user'

import GuardLoadingScreen from './GuardLoadingScreen'

import type { PropsWithChildren, ReactNode } from 'react'

interface RoleGuardProps extends PropsWithChildren {
    allowedRoles: StoreRole[]
    fallback?: ReactNode
}

function StoreRoleGuard({ allowedRoles, fallback, children }: RoleGuardProps) {
  const { data: user, isLoading } = useUser()
  const { role: effectiveRole } = useCurrentStore()

  if (isLoading) return <GuardLoadingScreen />
  if (!user) return null // should not happen, as useUser would be in error state

  if (!allowedRoles.includes(effectiveRole)) {
    if (fallback) return fallback
    return <NoAccessRoute />
  }

  return children
}

export default StoreRoleGuard